import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { tick } from '@angular/core/testing';

@Injectable()
export class NotificationService {

  constructor(private matSnackBar: MatSnackBar, private router: Router) {
    // router.events.subscribe(() => this.clear());
  }

  success(message: string, action?: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['success-message'];

    this.matSnackBar.open(message, action ? action : 'DISMISS', config);
    setTimeout(() => this.matSnackBar.dismiss(), 3000);

  }

  error(message: string, action?: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['error-message'];

    this.matSnackBar.open(message, action ? action : 'DISMISS', config );
    setTimeout(() => this.matSnackBar.dismiss(), 3000);
  }

  info(message: string) {
  }

  warn(message: string) {
  }

  clear() {
    this.matSnackBar.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/notification.service.ts